import Immutable from "seamless-immutable";

const initialState = Immutable({});

const PromotionReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default PromotionReducer;
